import { render, staticRenderFns } from "./ModalEditTemporaryStudent.vue?vue&type=template&id=5e164263&scoped=true&lang=pug&"
import script from "./ModalEditTemporaryStudent.vue?vue&type=script&lang=ts&"
export * from "./ModalEditTemporaryStudent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e164263",
  null
  
)

export default component.exports